import { useState } from 'react';
import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_KEY } from '@/components/utils/constants';

export interface CreateSharedPaymentResult {
  success: boolean;
  url?: string;
  error?: 'link_not_found' | 'link_expired' | 'invalid_password' | 'stripe_not_configured' | 'network_error' | string;
}

export const useSharedPayment = (shareToken: string) => {
  const [isCreatingPayment, setIsCreatingPayment] = useState(false);
  const [paymentError, setPaymentError] = useState<string | null>(null);

  const createPaymentLink = async (password?: string, customerEmail?: string): Promise<CreateSharedPaymentResult> => {
    setIsCreatingPayment(true);
    setPaymentError(null);
    
    try {
      // Create a fresh Supabase client without auth
      const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
      
      const payload: any = { shareToken };
      if (password) {
        payload.password = password;
      }
      if (customerEmail) {
        payload.customerEmail = customerEmail;
      }
      
      console.log('[useSharedPayment] Calling create-shared-payment-link:', { shareToken, hasPassword: !!password });
      
      const { data: result, error: err } = await supabase.functions.invoke(
        'create-shared-payment-link',
        {
          body: JSON.stringify(payload),
        }
      );
      
      if (err) {
        console.error('Edge function error:', err);
        setPaymentError('network_error');
        return { success: false, error: 'network_error' };
      }
      
      if (!result || !result.success) {
        const errorMsg = result?.error || 'unknown_error';
        setPaymentError(errorMsg);
        return { success: false, error: errorMsg };
      }
      
      return { success: true, url: result.url };
    } catch (e) {
      console.error('Network error:', e);
      setPaymentError('network_error');
      return { success: false, error: 'network_error' };
    } finally {
      setIsCreatingPayment(false);
    }
  };

  return { createPaymentLink, isCreatingPayment, paymentError };
};
